/**
 * Centralized role and candidate type definitions
 * Single source of truth for all Auth0 role IDs
 *
 * NOTE: New role IDs use placeholder values (rol_NEW_*).
 * These need to be created in Auth0 dashboard and updated here.
 */

// Primary role IDs
export const ROLE_IDS = {
    INTERVIEWER: 'rol_HXwp7bRcdBIFqp8u',
    MANAGER: 'rol_ndBoJF3ROg0eczNi',
  } as const;

  // Candidate type role IDs
  export const CANDIDATE_TYPE_ROLES = {
    // TECHNOLOGY
    engineer: 'rol_wFaiBVFAmyZl7cm6',
    product_manager: 'rol_y5v43QnjNIksoaXh',  
    data_scientist: 'rol_8gzwbP953SLFWtqJ',  
    devops_engineer: 'rol_v4aZRkr77XQSpXbu',  

    // BUSINESS & CONSULTING
    strategist: 'rol_kMmUXIQ71ERG9xfb',
    management_consultant: 'rol_YkXKjG2qvu1SJY5y',  
    business_analyst: 'rol_LleAcfAC87JhXc11',  
    operations_manager: 'rol_GxxvgVaptsnGBnm2',  

    // FINANCE
    analyst: 'rol_Ecg0owg4Q9DGgoC4',
    investment_banker: 'rol_FPZqT64MKHuZqUqm',  
    quant: 'rol_0WKaoDlplvS5miuC',  
    accountant: 'rol_7YByeWfkpHKuUVbg',  

    // MARKETING & SALES
    marketing_manager: 'rol_3YazviPljJgNdQlG',  
    sales_representative: 'rol_Nx0vrKWtyrLxwXkM',  
    growth_marketer: 'rol_rjIZoQVu2tD3NnOw',  

    // DESIGN & CREATIVE
    ux_designer: 'rol_DJVBe08rAKLcNUEi',  
    product_designer: 'rol_tByoAWxXQq7BnXKe',  

    // HUMAN RESOURCES
    hr_business_partner: 'rol_VovRH93rg27z1LyL',  
    recruiter: 'rol_q68ETiCOzAQ8nsXE',  
  } as const;
  
  // All role IDs combined for easy lookup
  export const ALL_ROLE_IDS = {
    ...ROLE_IDS,
    ...CANDIDATE_TYPE_ROLES,
  } as const;
  
  // TypeScript types
  export type RoleId = typeof ROLE_IDS[keyof typeof ROLE_IDS];
  export type CandidateTypeId = keyof typeof CANDIDATE_TYPE_ROLES;
  export type CandidateTypeRoleId = typeof CANDIDATE_TYPE_ROLES[CandidateTypeId];
  export type AnyRoleId = RoleId | CandidateTypeRoleId;
  
  // Helper to check if a role ID is a candidate type
  export const isCandidateTypeRole = (roleId: string): roleId is CandidateTypeRoleId => {
    return Object.values(CANDIDATE_TYPE_ROLES).includes(roleId as CandidateTypeRoleId);
  };
  
  // Helper to get candidate type from role ID
  export const getCandidateTypeFromRoleId = (roleId: string): CandidateTypeId | null => {
    const entry = Object.entries(CANDIDATE_TYPE_ROLES).find(([_, id]) => id === roleId);
    return entry ? (entry[0] as CandidateTypeId) : null;
  };
  
  // Helper to check if user has a specific role
  export const hasRole = (userRoles: { id: string }[], roleId: string): boolean => {
    return userRoles.some(role => role.id === roleId);
  };